export const SEND_USER_DETAILS_REQUEST = 'SEND_USER_DETAILS_REQUEST';
export const SEND_USER_DETAILS_SUCCESS = 'SEND_USER_DETAILS_SUCCESS';
export const SEND_USER_DETAILS_FAILURE = 'SEND_USER_DETAILS_FAILURE';
export const sendObUserDetailsSuccess = (payload) => ({
    type: SEND_USER_DETAILS_SUCCESS,
    payload,
});
export const sendObUserDetailsRequest = (payload) => ({
    type: SEND_USER_DETAILS_REQUEST,
    payload,
});
export const sendObUserDetailsFailure = (payload) => ({
    type: SEND_USER_DETAILS_FAILURE,
    payload,
});
